// @flow

import updateOrderGroupName from '../../../Services/updateOrderGroupName';
import type { UpdateOrderGroupNameParams } from '../../../types';

export default (params: UpdateOrderGroupNameParams) => async (dispatch: Function) => dispatch(updateOrderGroupName(params));